import React from 'react'
import { 
    SiteHeader,
    MenuItem,
    Footer,
    FooterBigmenu,
    FooterBottom,
    FooterColumn,
    FooterMenu
} from 'kunstmuseum-components'
import { ArrowUp } from 'kunstmuseum-icons'
import { gsap, ScrollToPlugin, Power2 } from 'gsap/all'
import ResizeObserver from 'resize-observer-polyfill'

import { allImagesLoadedEvent } from '../events'

import NavigationDrawer from './navigation-drawer'
import NavCard from './nav-card'
import LogoWhite from '../images/logo_white.svg'
import LogoBlack from '../images/logo_black.svg'
import Poster from '../images/Poster.jpg'
import PublicationCover from '../images/Kuball_Katalog_cover.jpg'
import Haus from '../images/200511_KMW_by_Kruszewski_0732.jpg'
import Veranstaltungen from '../images/210511_KWM_by_Kruszewski__MK_6341.jpg'
import WobLogo from '../images/WOB_Logo_042014-01.svg'

import 'swiper/swiper.scss'
import 'swiper/components/effect-coverflow/effect-coverflow.scss'
import '../styles/main.scss'

if (typeof window !== 'undefined') window.ResizeObserver = ResizeObserver

gsap.registerPlugin(ScrollToPlugin)

class Layout extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isScrolled: false,
            navIsOpen: false
        }

        this.onScroll = this.onScroll.bind(this)
        this.toggleNavigationDrawer = this.toggleNavigationDrawer.bind(this)
        this.triggerAllImagesLoadedEvent = this.triggerAllImagesLoadedEvent.bind(this)
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll)
        this.triggerAllImagesLoadedEvent()
    }

    triggerAllImagesLoadedEvent() {
        const images = document.images, 
              length = images.length

        let counter = 0;
    
        [].forEach.call( images, function( images ) {
            if(images.complete)
                incrementCounter()
            else
                images.addEventListener( 'load', incrementCounter, false )
        } );
        
        function incrementCounter() {
            counter++
            if ( counter === length ) {
                document.dispatchEvent(allImagesLoadedEvent)
            }
        }
    }

    onScroll() {
        this.setState({
            isScrolled: window.scrollY > 0
        })
    }

    toggleNavigationDrawer(event) {
        if (event) event.preventDefault()

        this.setState({
            navIsOpen: this.state.navIsOpen ? false : true
        })
    }

    scrollBackToTop(event) {
        event.preventDefault()

        gsap.to(window, {
            duration: 1,
            scrollTo: 0,
            ease: Power2.easeInOut
        })
    }

    render() {
        return (
            <>
                {this.state.navIsOpen &&
                    <NavigationDrawer closeFunc={this.toggleNavigationDrawer}>
                        <nav>
                            <ol>
                                <MenuItem link="#platonsmirror"><i>platon’s mirror</i>, 2001</MenuItem>
                                <MenuItem link="#brocaremix"><i>broca Re:Mix</i>, 2007</MenuItem>
                                <MenuItem link="#platonsmirrorimageapparatusctblitz"><i>platon’s mirror_image apparatus_ct_blitz</i>, 2011</MenuItem>
                                <MenuItem link="#fivesunsaftergalileo"><i>five suns / after Galileo</i>, 2018</MenuItem>
                                <MenuItem link="#magazindesjahrhundertsmagazineofthethcentury"><i>Magazin des 20. Jahrhunderts [Magazine of the 20th Century]</i>, 1989/90</MenuItem>
                                <MenuItem link="#researchdesknoldekritikkuball"><i>research_desk_Nolde/Kritik/Kuball</i>, 2020</MenuItem>
                                <MenuItem link="#marfafloaterindooroutdoor"><i>Marfa Floater (indoor/outdoor)</i>, 2009</MenuItem>
                                <MenuItem link="#berlinfloateroutdoordrone"><i>Berlin Floater (outdoor/drone)</i>, 2019</MenuItem>
                                <MenuItem link="#makingofmnemosyneafterabywarburg"><i>making of Mnemosyne (after Aby Warburg)</i>, 2021</MenuItem>
                                <MenuItem link="#fiveplanets"><i>five planets</i>, 2015</MenuItem>
                                <MenuItem link="#publicprepositionmaterialsammlung"><i>public preposition (Materialsammlung)</i>, seit 2009</MenuItem>
                            </ol>
                        </nav>
                        <section className="nav-cards">
                            <NavCard 
                                image={Poster}
                                buttonLink="https://www.kunstmuseum.de/ausstellung/mischa-kuball-referenzraeume/" 
                                buttonText="Webseite"
                            >
                                <em>Mischa Kuball</em><br/>
                                ReferenzRäume<br/>
                                8. 5. &#8202;—<br/>19. 9. 2021
                            </NavCard>
                            <NavCard
                                image={PublicationCover}
                                buttonLink="https://shop.kunstmuseum.de/produkt/mischa-kuball-referenzraeume-publikation/"
                                buttonText="Shop"
                            >
                                <em>Mischa Kuball. ReferenzRäume</em><br/><br/>
                                ca. 360 Seiten<br/>
                                38,00 €
                            </NavCard>
                            <NavCard
                                image={Haus}
                                buttonLink="https://www.kunstmuseum.de/besuch/"
                                buttonText="Besuch"
                            >
                                Eintrittspreise: <br/>
                                10 Euro, <br/>
                                ermäßigt 8 Euro
                            </NavCard>
                            <NavCard
                                image={Veranstaltungen}
                                buttonLink="https://www.kunstmuseum.de/kalender/?event_exhibition=4110"
                                buttonText="Veranstaltungen"
                            >
                                Digitales und analoges Begleitprogramm
                            </NavCard>
                        </section>
                        <section className="credits">
                            <p>
                                Verantwortlich: Dr. Katharina Derlin<br/>
                                Umsetzung: Tom Luca Schmidt/MSCG
                            </p>
                        </section>
                    </NavigationDrawer>
                }
                <SiteHeader
                    logo={this.state.isScrolled ? LogoBlack : LogoWhite}
                    overrideHamburgerAction={this.toggleNavigationDrawer}
                    logoOnClick={this.scrollBackToTop}
                    transparent={!this.state.isScrolled}
                    lightText={!this.state.isScrolled}
                >
                    <MenuItem onClick={this.toggleNavigationDrawer}>Menü</MenuItem>
                </SiteHeader>
                <main>{this.props.children}</main>
                <a id="back-to-top" className={this.state.isScrolled && 'visible'} href="#" onClick={this.scrollBackToTop} role="button">
                    <span className="screen-reader-text">An den Anfang springen</span>
                    <ArrowUp />
                </a>
                <Footer>
                    <FooterBigmenu>
                        <MenuItem link="https://www.kunstmuseum.de/newsletter/">Newsletter</MenuItem>
                        <MenuItem link="https://www.instagram.com/kunstmuseumwolfsburg/">Instagram</MenuItem>
                        <MenuItem link="https://twitter.com/kunstmuseumwob">Twitter</MenuItem>
                        <MenuItem link="https://www.facebook.com/KunstmuseumWolfsburg">Facebook</MenuItem>
                        <MenuItem link="https://www.youtube.com/user/KunstmuseumWolfsburg">YouTube</MenuItem>
                    </FooterBigmenu>
                    <FooterBottom>
                        <FooterColumn>
                            <p>
                                Hollerplatz 1<br />
                                38440 Wolfsburg
                            </p>
                        </FooterColumn>
                        <FooterColumn>
                            <p>
                                +49 (0)5361 26690<br />
                                info@kunstmuseum.de
                            </p>
                        </FooterColumn>
                        <FooterColumn>
                            <FooterMenu>
                                <MenuItem link="https://www.kunstmuseum.de/impressum">Impressum</MenuItem>
                                <MenuItem link="https://www.kunstmuseum.de/datenschutz">Datenschutzerklärung</MenuItem>
                            </FooterMenu>
                        </FooterColumn>
                    </FooterBottom>
                </Footer>
            </>
        )
    }
}

export default Layout